const infos = []
const warnings = []

function info(message) {
  infos.push(message)
}

function warn(message) {
  warnings.push(message)
}

function all(message) {
  info(message)
  warn(message)
}

function getLogs() {
  return infos
}

function getWarnings() {
  return warnings
}

export default {
  all,
  info,
  warn,
  getLogs,
  getWarnings
}
